/* eslint-disable no-param-reassign */
// mapbox-gl-draw modes work by mutating the state and display features they
// are handed; that is the contract, not an accident.
import MapboxDraw from '@mapbox/mapbox-gl-draw';
import { Feature } from 'geojson';
import createSupplementaryPointsForCircle from './createSupplementaryPointsForCircle';

const { constants: Constants, lib } = MapboxDraw;

// A copy, not the library's own simple_select: the plugin this replaces
// mutated the shared built-in mode at import time.
const SimpleSelectMode: MapboxDraw.DrawCustomMode = {
  ...MapboxDraw.modes.simple_select,

  dragMove(
    this: MapboxDraw.DrawCustomModeThis,
    state: any,
    e: MapboxDraw.MapMouseEvent
  ) {
    state.dragMoving = true;
    e.originalEvent.stopPropagation();

    const delta = {
      lng: e.lngLat.lng - state.dragMoveLocation.lng,
      lat: e.lngLat.lat - state.dragMoveLocation.lat
    };
    lib.moveFeatures(this.getSelected(), delta);
    // The stored centre has to travel with the polygon or the next resize
    // would grow the circle from where it used to be.
    this.getSelected()
      .filter(feature => feature.properties?.isCircle)
      .map(feature => feature.properties?.center)
      .forEach(center => {
        center[0] += delta.lng;
        center[1] += delta.lat;
      });

    state.dragMoveLocation = e.lngLat;
  },

  toDisplayFeatures(state: any, geojson: Feature, display) {
    const active = this.isSelected(geojson.properties?.id)
      ? Constants.activeStates.ACTIVE
      : Constants.activeStates.INACTIVE;
    geojson.properties = { ...geojson.properties, active };
    display(geojson);
    (this as any).fireActionable();
    if (
      active !== Constants.activeStates.ACTIVE ||
      geojson.geometry.type === Constants.geojsonTypes.POINT
    ) {
      return;
    }
    const supplementaryPoints = geojson.properties.user_isCircle
      ? createSupplementaryPointsForCircle(geojson)
      : lib.createSupplementaryPoints(geojson);
    supplementaryPoints?.forEach(display);
  }
} as MapboxDraw.DrawCustomMode;

export default SimpleSelectMode;
